import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger, Button } from 'react-bootstrap';
import gql from 'graphql-tag';
import Icon from '../../../modules/react/components/stateless/Icon';
import { MANAGE } from '../../../modules/authorization/actions';
import { ACCESS_SOFTWARE_SETTINGS } from '../../../modules/authorization/subjects';
import useCurrentUser from '../../hooks/useCurrentUser';
import styles from './styles.scss';

const propTypes = {
  company: PropTypes.shape({
    corporateUrl: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {};

const AdvancedSettingsButton = ({ company: { corporateUrl } }) => {
  const currentUser = useCurrentUser();
  const authorized = currentUser.can(MANAGE, ACCESS_SOFTWARE_SETTINGS);

  const tooltip = (
    <Tooltip id="advanced-settings">
      You do not have permissions for Advanced Settings. Please contact support.
    </Tooltip>
  );

  const advancedButton = (
    <Button
      variant="primary"
      disabled={!authorized}
      className={styles.linkToUpButton}
      href={`${corporateUrl}/settings/website`}
    >
      <span className={styles.advButtonText}>Advanced Settings</span>
      <Icon id="external-link" label="Advanced Settings" />
    </Button>
  );

  return authorized ? advancedButton : (
    <OverlayTrigger
      placement="left"
      overlay={tooltip}
      trigger={['hover', 'focus']}
    >
      {advancedButton}
    </OverlayTrigger>
  );
};

AdvancedSettingsButton.propTypes = propTypes;
AdvancedSettingsButton.defaultProps = defaultProps;

AdvancedSettingsButton.fragments = {
  company: gql`
    fragment AdvancedSettingsButtonCurrentCompany on Company {
      corporateUrl
    }
  `,
};

export default AdvancedSettingsButton;
